

import { motion, useMotionValue, useMotionValueEvent, useScroll } from 'framer-motion';
// import hmBlueSign from "../../Assets/images/HM_SIGN_BLUE.png";
import hmBlueSign from "../../Assets/images/white-logo.png";
// import { NavLink } from 'react-router-dom';
// import { mainRouteInitial } from '../../Data/Constant';
import { useMediaQuery } from "@react-hook/media-query";
import { useEffect, useState } from 'react';
// import useMenuInit from "./useMenuInit";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

import "./Header.css";
import { NavLink } from 'react-router-dom';
import { mainRouteInitial } from '../../Data/Constant';

const MainSiteHeader = ({ isPreloaderDone = false }) => {
    const isMobile = useMediaQuery("(max-width: 1024px)");
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    const { scrollY } = useScroll();  // Track scroll position
    const y = useMotionValue(0);  // Control header Y position

    let prevScrollY = 0;

    // Listen to scroll changes (runs on every tick)
    useMotionValueEvent(scrollY, "change", (current) => {
        const direction = current - prevScrollY;

        // 🔹 Header color logic
        if (current > 50) {
            setScrolled(true);
        } else {
            setScrolled(false);
        }

        if (current < 50) {
            // Near top: Always show
            y.set(0);
        } else if (direction > 0) {
            // Scroll down: Hide (slides up)
            y.set(-150);
        } else {
            // Scroll up (even 1px): Show (slides down)
            y.set(0);
        }

        prevScrollY = current;
    });

    useEffect(() => {
        if (!isMobile) {
            setMenuOpen(false);
            document.body.style.overflow = "";
            return;
        }

        if (menuOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [menuOpen, isMobile]);



    return (
        <>
            {isMobile && (
                <div className={`th-menu-wrapper ${menuOpen ? "th-body-visible" : ""}`} onClick={() => setMenuOpen(false)}>
                    <div className="th-menu-area text-center">
                        <button className="th-menu-toggle thmenutoggle">
                            <span className="material-symbols-outlined">close</span>
                        </button>
                        <div className="mobile-logo">
                            <NavLink to={`/${mainRouteInitial}/Home`}>
                                <img style={{ width: '180px', height: 'auto' }} src={hmBlueSign} alt="Harsh Sanghavi" fetchpriority="high" />
                            </NavLink>
                        </div>
                        <div className="th-mobile-menu">
                            <ul>
                                <li>
                                    <NavLink title="Home" to={`/${mainRouteInitial}/Home`}>
                                        Home
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink title="Blogs" to={`/${mainRouteInitial}/Blog`}>
                                        Blogs
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink title="Contact Us" to={`/${mainRouteInitial}/ContactUs`}>
                                        Contact Us
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}

            <motion.header
                initial={{ y: -150 }} // Start hidden above
                animate={{ y: isPreloaderDone ? 0 : -150 }} // Only slide in when preloader is done
                transition={{
                    duration: 0.5,
                    ease: [0.76, 0, 0.24, 1], // Same curve as harshsanghavi.co.in
                    delay: 0.1 // Small delay after preloader for premium feel
                }}
                style={{
                    y,
                    position: 'fixed',
                    // top: 0,
                    // left: 0,
                    // width: '100%',
                    // padding: "20px 50px",
                    zIndex: 999,
                    // background: 'rgba(255, 255, 255, 0.95)',
                    // backdropFilter: 'blur(10px)',
                    // WebkitBackdropFilter: 'blur(10px)',
                }}
                id='site_menu_header'
                // className="site-header nav-bg dsn-hamburger"
                // className={`th-header header-layout2 header-layout6 ${isMobile ? "dsn-hamburger" : ""} ${isMobile && menuOpen ? "mobile-open" : ""}`}
                className={`th-header header-layout2 header-layout6`}
            // ref={menuRef}
            >

                <div className="sticky-wrapper">
                    <div className="menu-area">
                        <div className="logo-bg" />
                        <div className={`main-header container th-container ${scrolled ? "header-scrolled" : ""}`}>
                            <div className="row align-items-center justify-content-between">
                                <div className="col-auto">
                                    <div className="header-logo pt-0 pb-0">
                                        <NavLink to={`/${mainRouteInitial}/Home`}>
                                            <img style={{ width: '180px', height: 'auto' }} src={hmBlueSign} alt="Harsh Sanghavi" fetchpriority="high" />
                                        </NavLink>
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <nav className="main-menu d-none d-lg-inline-block">
                                        <ul>
                                            <li>
                                                <NavLink title="Home" to={`/${mainRouteInitial}/Home`}>
                                                    Home
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink title="Blogs" to={`/${mainRouteInitial}/Blog`}>
                                                    Blogs
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink title="Contact Us" to={`/${mainRouteInitial}/ContactUs`}>
                                                    Contact Us
                                                </NavLink>
                                            </li>
                                        </ul>
                                    </nav>
                                    <button type="button" className="th-menu-toggle d-block d-lg-none" onClick={() => setMenuOpen(true)}><FontAwesomeIcon icon={faBars} /></button>
                                </div>
                                {/* <div className="col-auto d-none d-xl-block"><div className="header-button"> */}
                                {/* <button type="button" className="icon-btn searchBoxToggler"><i className="far fa-search" /></button> 
            <a href="contact.html" className="th-btn">Free Consultation<i className="fas fa-arrow-right ms-2" /></a> 
            <button type="button" className="icon-btn sideMenuInfo"><i className="far fa-bars" /></button> */}
                                {/* </div>
            </div> */}
                            </div></div></div></div>
            </motion.header>
        </>
    );
};

export default MainSiteHeader;